module.exports = __webpack_public_path__ + "static/media/01A.6fe11650.png";